import { render, staticRenderFns } from "./e-file-uploaded.vue?vue&type=template&id=fc23c544&scoped=true&lang=pug"
import script from "./e-file-uploaded.vue?vue&type=script&lang=js"
export * from "./e-file-uploaded.vue?vue&type=script&lang=js"
import style0 from "./e-file-uploaded.vue?vue&type=style&index=0&id=fc23c544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc23c544",
  null
  
)

export default component.exports